import { Flex } from "antd";
import styled from "styled-components";

export const BarcodeItem = styled(Flex)`
  background-color: #efefef;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 10px;
`

export const BarcodeWrap = styled.div`
  max-height: 70vh;
  min-height: 30vh;
  overflow-y: auto;
`

export const ContentWrap = styled.div`
  width: 100%;
`